import { truncatedStyle } from '@bingads-webui-campaign-react/common-styles';

export const getIntelligenceCommonStyles = (_, { palette = {} }) => ({
  '& input[type=button]': {
    '&:focus': {
      outline: `1px solid ${palette.neutralSecondaryAlt}`,
      boxShadow: `inset 0 0 0 1px ${palette.neutralSecondary}`,
      outlineOffset: 0,
      border: `2px solid ${palette.white}`,
    },
  },
  ...truncatedStyle,
});
